module.exports = __webpack_public_path__ + "img/box.83654b8a.png";